import { Component } from '@angular/core';
import { iBisBaseComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { EditPackageService } from './edit-package.service';

@Component({
    selector: 'app-edit-package',
    templateUrl: './edit-package.component.html'
})
export class EditPackageComponent extends iBisBaseComponent {

    public declare edit: EditPackageService;
    constructor(public proxy: ProxyService) {
        super(proxy.packages, proxy.lg, proxy.iui, proxy.activatedRoute);
    }
}
